export const SPECIFIC_HOUR_ROUTE = '/settings/hours/specific';
export const DELIVERY_HOUR_ROUTE = '/settings/hours/delivery';
export const OPENED_HOUR_ROUTE = '/settings/hours';
export const PRINTER_ROUTE = '/settings/printers';
export const PAYMENTS_ROUTE = '/settings/payments';
export const SALES_TYPE_ROUTE = '/settings/sales-type';
export const HUBRISE_ROUTE = '/settings/hubrise';
export const GENERAL_CONFIG_ROUTE = '/settings/general';
export const DELIVERY_ZONE_ROUTE = '/settings/delivery/zone';
export const DELIVERY_SETTINGS_ROUTE = '/settings/delivery/fees';
export const ORDER_SETTINGS_ROUTE = '/settings/orderSettings';
export const GENERAL_DESIGN_ROUTE = '/marketing/generalDesign';
export const WEB_DESIGN_ROUTE = '/marketing/webDesign';
export const MOBILE_DESIGN_ROUTE = '/marketing/mobileDesign';
export const PUSH_NOTIF_ROUTE = '/marketing/notification';
export const CODE_PROMO_ROUTE = '/marketing/code-promo';
export const FEDILITY_PROGRAM_ROUTE = '/marketing/loyalty';
export const ACTIVATION_ROUTE = '/marketing/activation';
export const MANAGEMENT_FEE_ROUTE = '/settings/management-fee';
export const DEEPLINK_ROUTE = '/marketing/deepLinks';
export const CAMPAIGN_PROMO_ROUTE = '/marketing/campaignPromo';
export const CAMPAIGNS_ROUTE = '/marketing/campaigns';
export const FAQ_ROUTE = '/help/FAQ';
export const CONTACT_SUPPORT_ROUTE = '/help/contact';
